import _ from 'lodash'

export default function getProductImages(product) {
  const imagePaths = [
    [
      'custitem_bbs_default_product_image.value',
      'custitem_bbs_normal_webpath_via_s3frnt.value'
    ],
    'custitem_bbs_imagelink1.value',
    'custitem_bbs_imagelink2.value'
  ]

  return imagePaths
    .map(path => {
      if (Array.isArray(path)) {
        for (let innerPath of path) {
          const img = _.get(product, innerPath)
          if (img) {
            return img
          }
        }
      } else {
        return _.get(product, path)
      }
    })
    .filter(o => o)
}

export { getProductImages }
